const earningsDrilldownDE = {
    "view": {
        "form": {
            "label": {
                "filters": "Filter",
                "monthRange": "Monatsbereich",
                "startingMonth": "Startmonat",
                "endingMonth": "Endmonat",
                "label": "Label",
                "store": "Shop",
                "release": "Veröffentlichung",
                "track": "Titel",
                "country": "Land",
                "subuser": "Subuser",
                "fetchingEarnings": "Einnahmestatistiken aus der Datenbank abrufen"
            },
            "button": {
                "generateReport": "Bericht erstellen",
                "resetFilters": "Filter zurücksetzen"
            },
            "options": {
                "store": {
                    "selectStore": "Shop auswählen",
                    "allStores": "Alle Shops"
                },
                "label": {
                    "selectLabel": "Label auswählen"
                },
                "country": {
                    "allCountries": "Alle Länder"
                },
                "release": {
                    "allReleases": "Alle Veröffentlichungen"
                },
                "track": {
                    "allTracks": "Alle Titel"
                },
                "subuser": {
                    "selectSubuser": "Subuser auswählen"
                },
                "period": {
                    "selectMonthRange": "Monatsbereich auswählen",
                    "last3Reports": "Letzte 3 Berichte",
                    "last6Reports": "Letzte 6 Berichte",
                    "last12Reports": "Letzte 12 Berichte",
                    "custom": "Benutzerdefiniert"
                }
            },
            "validation": {
                "monthRangeRequired": "* Monatsbereich-Filter ist erforderlich",
                "labelRequired": "* Label-Filter ist erforderlich"
            }
        },
        "royaltiesSummary": {
            "title": "Lizenzgebührenübersicht",
            "subtitle": "Übersicht des ausgewählten Monatsbereichs",
            "label": {
                "monthRangeText": "Letzte 12 Abrechnungen",
                "revenueEUR": "Einnahmen (€)",
                "combinedRevenue": "Kombinierte Einnahmen",
                "combinedRevenueEUR": "Kombinierte Einnahmen (€)",
                "otherStores": "Andere Shops"
            }
        },
        "storeWiseRevenuePercentage": {
            "title": "Shop-spezifischer Einnahmenanteil"
        },
        "storeWiseRevenueBreakdown": {
            "title": "Shop-spezifische Einnahmenaufteilung",
            "label": {
                "revenue": "Einnahmen"
            }
        },
        "revenueByTerritory": {
            "title": "Einnahmen nach Gebiet"
        },
        "top5Releases": {
            "title": "Top 5 Veröffentlichungen",
            "table": {
                "column": {
                    "releaseName": "Veröffentlichungsname",
                    "revenue": "Einnahmen"
                }
            }
        },
        "top5Tracks": {
            "title": "Top 5 Titel",
            "table": {
                "column": {
                    "trackName": "Titelname",
                    "revenue": "Einnahmen"
                }
            }
        },
        "message": {
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>setzen</1> Sie Ihr Abonnement fort, um diese Funktion zu nutzen.",
            "subscriptionUpgrade": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen."
        }
    }
};

export default earningsDrilldownDE;